import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected"; 
import { CHART_COLORS_THREE, CHART_COLORS, CHART_COLORS_TWO, CHART_MAX_VALUES } from 'constant/variables';



export default function EmployeeTargetChart(props) {
  const [viewData, setViewData] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const {outletper} = props;

   useEffect(() => {
    if (outletper) {
      if (outletper.length === 0) {
        const viewDetail = [];
        const details = {
          year: "Data Not Available",
          income: 0,
          expenses: 0,
          sales: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = outletper;
        const viewDetail = [];
        let count = 0;
        let totalSales = 0;
        for (let index = 0; index < clinic.length; index++) {
          if((index + 1) > CHART_MAX_VALUES) {
            break;
          }

          // if(props.outlet && props.outlet !== clinic[index].OutletName) {

          // }else {
            totalSales += parseInt(clinic[index].TotalSales);
            const details = {
              name: clinic[index].Name,
              value: parseInt(clinic[index].TotalSales),
              target: clinic[index].TotalTarget,
              achieved_percentage: clinic[index].TotalAchievedPercentage,
              children: [
                { 
                  name: "HBB", 
                  value: parseInt(clinic[index].HBBSales),
                  target: clinic[index].HBBTarget,
                  achieved_percentage: clinic[index].HBBAchievedPercent,
                },
                { 
                  name: "Baqati", 
                  value: parseInt(clinic[index].BaqatiSales), 
                  target: clinic[index].BaqatiTarget,
                  achieved_percentage: clinic[index].BaqatiAchievedPercent,
                },
                { 
                  name: "Hayyak", 
                  value: parseInt(clinic[index].HayyakSales), 
                  target: clinic[index].HayyakTarget,
                  achieved_percentage: clinic[index].HayyakAchievedPercent,
                },
                { 
                  name: "Upgrade",
                  value: parseInt(clinic[index].UpgradeSales), 
                  target: clinic[index].UpgradeTarget,
                  achieved_percentage: clinic[index].UpgradeAchievedPercent,
                },
              ]
            }
            count++;
            setTotalSales(totalSales);
            viewDetail.push(details);
          // }
        }

        setViewData(viewDetail);
      }
    }
  }, [outletper, props.outlet]);

  useLayoutEffect(() => {
    am4core.useTheme(am4themes_animated);
    // Create chart instance

    var chart = am4core.create("chartdiv", am4plugins_forceDirected.ForceDirectedTree);
    var networkSeries = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries())
    chart.colors.list = CHART_COLORS;
    chart.data = [
      {
        name: props.outlet,
        value: totalSales,
        children: viewData,
        // children: [
        //   {
        //     name: "Employee 1",
        //     children: [
        //       { name: "HBB", value: 100 },
        //       { name: "Baqati", value: 60 },
        //       { name: "Hayyak", value: 60 },
        //       { name: "Upgrade", value: 60 },
        //     ]
        //   },
        //   {
        //     name: "Employee 2",
        //     children: [
        //       { name: "HBB", value: 100 },
        //       { name: "Baqati", value: 60 },
        //       { name: "Hayyak", value: 60 },
        //       { name: "Upgrade", value: 60 },
        //     ]
        //   },
        //   {
        //     name: "Employee 3",
        //     children: [
        //       { name: "HBB", value: 90 },
        //       { name: "Baqati", value: 100 },
        //       { name: "Hayyak", value: 40 },
        //       { name: "Upgrade", value: 70 },
        //     ]
        //   },
        //   {
        //     name: "Employee 4",
        //     children: [
        //       { name: "HBB", value: 30 },
        //       { name: "Baqati", value: 90 },
        //       { name: "Hayyak", value: 20 },
        //       { name: "Upgrade", value: 100 },
        //     ]
        //   },
        //   {
        //     name: "Employee 5",
        //     children: [
        //       { name: "HBB", value: 90 },
        //       { name: "Baqati", value: 50 },
        //       { name: "Hayyak", value: 80 },
        //       { name: "Upgrade", value: 20 },
        //     ]
        //   }
    
        // ]
      }
    ];
    
    networkSeries.dataFields.value = "value";
    networkSeries.dataFields.name = "name";
    networkSeries.dataFields.children = "children";
    // networkSeries.nodes.template.tooltipText = "{name}:{value}";
    networkSeries.nodes.template.tooltipText = "{name}\nSales: {value}\nTarget: {target}\nAchievement: {achieved_percentage}%";
    networkSeries.nodes.template.fillOpacity = 1;
    
    networkSeries.nodes.template.label.text = "{name}"
    networkSeries.fontSize = 10;
    
    networkSeries.links.template.strokeWidth = 1;
    
    var hoverState = networkSeries.links.template.states.create("hover");
    hoverState.properties.strokeWidth = 3;
    hoverState.properties.strokeOpacity = 1;
    
    networkSeries.nodes.template.events.on("over", function(event) {
      event.target.dataItem.childLinks.each(function(link) {
        link.isHover = true;
      })
      if (event.target.dataItem.parentLink) {
        event.target.dataItem.parentLink.isHover = true;
      }
    
    })
    
    networkSeries.nodes.template.events.on("out", function(event) {
      event.target.dataItem.childLinks.each(function(link) {
        link.isHover = false;
      })
      if (event.target.dataItem.parentLink) {
        event.target.dataItem.parentLink.isHover = false;
      }
    })
    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv" style={{ width: "100%",
    height:"550px",
    maxWidth:"100%" }} />;
}
